import script from "./DomainModelSystemTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelSystemTable.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelSystemTable.vue?vue&type=style&index=0&id=4a875d9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a875d9d"]])

export default __exports__